import React, { PropsWithChildren, useMemo } from 'react'
import { useTheme } from 'styled-components'

import { PropsWithClassName } from '@helper/PropsWithClassName'

import { Contract as ContractType } from '@definitions/types/symfonyTypesd'

import { Contract } from '../Contract/Contract'
import { Root } from './Contracts.styles'

export interface Affiliation {
  id: number
}

export interface Cost {
  id: number
}

interface Props extends PropsWithClassName {
  contracts: ContractType[]
  handleSelectContract?: (contract: ContractType) => void
}

const Contracts: React.FC<PropsWithChildren<Props>> = (
  props: PropsWithChildren<Props>
): React.ReactElement => {
  const { contracts, handleSelectContract } = props
  const theme: any = useTheme()

  const contractsFiltered = useMemo(
    () =>
      contracts
        .filter((contract) => {
          return (
            contract.standard &&
            (contract.affiliations?.edges ?? []).filter(
              (e) => e?.node?.name.toLowerCase() === theme.key
            ).length > 0
          )
        })
        .sort((a, b) => a.weeklyFee - b.weeklyFee),
    [contracts, theme.key]
  )

  return (
    <Root className={props.className} dataTestId={'contracts-root'}>
      {contractsFiltered.map((contract, index) => {
        return (
          <Contract
            cols={{ xs: 12, sm: 12, md: 6, lg: 6 }}
            handleSelectContract={handleSelectContract}
            key={contract.id + index}
            contract={contract}
            button
          />
        )
      })}
    </Root>
  )
}

export { Contracts }
